<template>
    <div class="qksm qksm11">
        <h4>十一、预算绩效情况说明</h4>
        <div v-if="num(qksm['绩效项目'])==0 && !isEmptyStr(qksm['绩效项目'])" class="nogap">
            <p class="hide_pdf">
                （绩效自评涵盖项目<reason type="integer" classname="qksm integer must" name="绩效项目" v-model:value="qksm['绩效项目']"></reason>个）
            </p>
            <p>
                本{{$parent.typeText}}未开展绩效管理工作。
                <reason placeholder="本部门未开展绩效管理工作的原因" type="textarea" classname="qksm widest" name="未开展绩效原因" v-model:value="qksm['未开展绩效原因']"></reason>
            </p>
        </div>
        <div v-else>
            <div class="nogap" v-if="$store.state.divData.type==0">
                <p>
                    <b class="tipsText hide_pdf">(备注①：按滨城财绩〔2021〕3号要求，占比应该是“100%”，未实现100%的请说明原因；自评工作成效和存在的问题请根据单位自评工作情况简要概述）</b>
                </p>
                <p>
                    根据预算绩效管理要求，我单位按照“谁用款、谁评价”的原则，组织对2020年度{{city}}级预算项目支出进行全面自评，
                    涵盖项目<reason type="integer" classname="qksm integer must" name="绩效项目" v-model:value="qksm['绩效项目']"></reason>个，
                    涉及预算资金<reason type="money" classname="qksm money " name="涉及预算资金" v-model:value="qksm['涉及预算资金']"></reason>万元，占单位预算项目支出总额的
                    <reason type="money" classname="qksm money " name="项目支出占比" v-model:value="qksm['项目支出占比']"></reason>%
                    <template v-if="num(qksm['项目支出占比'])!=100">
                        ，
                        <reason placeholder="未实现100%的原因" type="textarea" classname="qksm widest" name="未实现百分比原因" v-model:value="qksm['未实现百分比原因']"></reason>
                    </template>
                    <template v-else>
                        。
                    </template>
                    开展绩效自评的
                    <reason type="integer" classname="qksm integer" name="绩效自评项目" v-model:value="qksm['绩效自评项目']"></reason>个项目中，
                    <reason type="integer" classname="qksm integer" name="绩效自评优" v-model:value="qksm['绩效自评优']"></reason>个项目自评等级为优，
                    <reason type="integer" classname="qksm integer" name="绩效自评良" v-model:value="qksm['绩效自评良']"></reason>个项目自评等级为良，
                    <reason type="integer" classname="qksm integer" name="绩效自评中" v-model:value="qksm['绩效自评中']"></reason>个项目自评等级为中
                    <template v-if="!isPdf || num(qksm['绩效自评差'])>0">
                        ，
                        <reason type="integer" classname="qksm integer" name="绩效自评差" v-model:value="qksm['绩效自评差']"></reason>个项目自评等级为差
                    </template>。
                    <span v-if="num(qksm['绩效自评项目'])!=0">
                        从自评情况看，
                        <reason type="textarea" classname="qksm widest" name="绩效自评结果情况" v-model:value="qksm['绩效自评结果情况']" placeholder="项目支出绩效管理的重视程度进一步提升，大部分项目有序开展，执行和完成情况较好，资金使用比较规范，……，但也存在部分项目产出指标低于预期、项目实施进展慢等问题，……"></reason>
                    </span>
                </p>
                <p class="hide_pdf upload" @click="uploadJx('zphzb')" v-if="num(qksm['绩效项目'])>0">*【->点此前往】上传绩效自评情况汇总表</p>
                <p v-if="isPdf && qksm['绩效项目']!=0 && qksm['自评表是否涉密']!='全部涉密'">2020年度预算项目支出绩效自评情况汇总表和{{city}}级预算项目支出绩效自评表详见“第五部分 附件”。</p>
                <p class="hide_pdf">
                    （绩效自评表是否涉密<reason type="select" classname="qksm select " name="自评表是否涉密" v-model:value="qksm['自评表是否涉密']"></reason>）<br />
                </p>
                <p v-if="qksm['自评表是否涉密']=='全部涉密'">
                    本单位开展的绩效自评结果按规定不予公开。
                </p>
                <template v-else>
                    <p v-if="qksm['自评表是否涉密']=='部分涉密'"><reason type="textarea" classname="qksm widest" name="自评表涉密说明" v-model:value="qksm['自评表涉密说明']" placeholder="若绩效自评表因涉密不能公开，请说明"></reason></p>
                    <p class="hide_pdf upload" @click="uploadJx('jxzpb')" v-if="num(qksm['绩效自评项目'])>0">*【->点此前往】上传绩效自评表</p>
                    <p>
                        <b class="tipsText hide_pdf">(备注②：自评表公开数量至少为1-3个，若自评项目总数不足3个，按照“应公开，尽公开”的原则，公开全部自评表；若部分涉密不能公开，请说明；若全部涉密不能公开，系统自动生成“本单位开展的绩效自评结果按规定不予公开”。）</b>
                    </p>
                </template>
                <p v-if="!isPdf || (isPdf && num(qksm['开展评价'])>0)">
                    组织对<reason type="textarea" classname="qksm nullable" name="开展部门项目" v-model:value="qksm['开展部门项目']" placeholder="“*”“*”"></reason>等
                    <reason type="integer" classname="qksm integer must nullable" name="开展评价" v-model:value="qksm['开展评价']"></reason>个项目开展了重点绩效评价，
                    涉及资金<reason type="money" classname="qksm money nullable" name="开展评价资金" v-model:value="qksm['开展评价资金']"></reason>万元。
                    <span class="hide_pdf">
                        <br />（是否委托第三方开展部门评价<reason type="select" classname="qksm select " name="是否第三方开展" v-model:value="qksm['是否第三方开展']"></reason>）<br />
                    </span>
                    <template v-if="qksm['是否第三方开展']=='是'">
                        其中，对
                        <reason type="textarea" classname="qksm" name="委托项目" v-model:value="qksm['委托项目']" placeholder="“*”“*”"></reason>等项目分别委托
                        <reason type="textarea" classname="qksm" name="第三方评价" v-model:value="qksm['第三方评价']" placeholder="“*”“*”"></reason>等第三方机构开展评价。
                    </template>
                    从评价情况来看，上述<reason type="integer" classname="qksm integer nullable" name="完成项目个数" v-model:value="qksm['完成项目个数']"></reason>个项目完成情况较好，
                    主要表现为：<reason type="textarea" classname="qksm widest nullable" name="部门评价主要表现" v-model:value="qksm['部门评价主要表现']" placeholder="项目立项程序完整、规范，设置了明确的绩效目标，财务相关管理制度较健全，预算执行及时、有效，群众满意度较高，基本实现了预期，……"></reason>
                    <span v-if="qksm['评价报告是否涉密']=='是'">
                        本单位开展的绩效评价项目按规定不予公开。
                    </span>
                    <span v-else-if="isPdf && attachments.filter(e=>e.claims.tag=='jxpjbg').length>0 && qksm['评价报告是否涉密']!='是'">绩效评价报告详见“第五部分 附件”。</span>
                </p>
                <p class="hide_pdf">
                    （是否涉密<reason type="select" classname="qksm select " name="评价报告是否涉密" v-model:value="qksm['评价报告是否涉密']"></reason>）<br />
                </p>
                <p class="hide_pdf upload" @click="uploadJx('jxpjbg')" v-if="num(qksm['开展评价'])>0">*【->点此前往】上传绩效评价报告</p>
                <p>
                    <b class="tipsText hide_pdf">（备注③：若开展重点绩效评价，则根据评价报告内容对项目成效及问题简要概述，并点击“上传绩效评价报告”中至少公开1个绩效评价报告；若绩效评价项目全为涉密项目，请选择是否涉密为是，系统自动生成为“本单位开展的绩效评价项目按规定不予公开。”）</b>
                </p>
            </div>
            <div class="nogap" v-else>
                <p>
                    <b>（一）预算绩效管理工作开展情况。</b>
                    <b class="tipsText hide_pdf">(备注①：自评项目总个数应与“(二)项目绩效自评结果”、自评情况汇总表保持一致；按要求，占比应该是“100%”，未实现100%的请说明原因）</b>
                </p>
                <p>
                    根据预算绩效管理要求，{{$store.state.divData.divname}}按照“谁用款、谁评价”的原则，组织对所属单位2020年度{{city}}级预算项目支出进行全面自评，
                    涵盖项目<reason type="integer" classname="qksm integer must" name="绩效项目" v-model:value="qksm['绩效项目']"></reason>个，
                    涉及预算资金<reason type="money" classname="qksm money " name="涉及预算资金" v-model:value="qksm['涉及预算资金']"></reason>万元，占部门预算项目支出总额的
                    <reason type="money" classname="qksm money " name="项目支出占比" v-model:value="qksm['项目支出占比']"></reason>%
                    <template v-if="num(qksm['项目支出占比'])!=100">
                        ，
                        <reason placeholder="未实现100%的原因" type="textarea" classname="qksm widest" name="未实现百分比原因" v-model:value="qksm['未实现百分比原因']"></reason>
                    </template>
                    <template v-else>
                        。
                    </template>
                </p>
                <p class="hide_pdf upload" @click="uploadJx('zphzb')" v-if="num(qksm['绩效项目'])>0">*【->点此前往】上传绩效自评情况汇总表</p>
                <p v-if="num(qksm['整体绩效得分'])==0 && isPdf">
                    部门整体绩效自评工作已启动，正在进行中。
                </p>
                <p v-else>
                    组织开展部门整体绩效自评，得分为
                    <reason type="money" classname="qksm money nullable" name="整体绩效得分" v-model:value="qksm['整体绩效得分']"></reason>分，等级为
                    <reason type="textarea" classname="qksm width3 nullable" name="整体绩效等级" v-model:value="qksm['整体绩效等级']" placeholder="优、良、中、差"></reason>。从自评情况来看，
                    <reason type="textarea" classname="qksm widest nullable" name="整体绩效自评情况" v-model:value="qksm['整体绩效自评情况']"></reason>
                </p>
                <p class="hide_pdf">
                    <b class="tipsText">（备注②：仅开展部门整体绩效管理试点的部门需要公开此段；未开展部门整体绩效管理试点的部门不需要填写，系统自动生成“部门整体绩效自评工作已启动，正在进行中。”）</b>
                </p>
                <p v-if="isPdf && num(qksm['开展评价'])==0">
                    本部门未开展部门评价。
                </p>
                <p v-else>
                    组织对<reason type="textarea" classname="qksm nullable" name="开展部门项目" v-model:value="qksm['开展部门项目']" placeholder="“*”“*”"></reason>等
                    <reason type="integer" classname="qksm integer must nullable" name="开展评价" v-model:value="qksm['开展评价']"></reason>个项目开展了部门评价，
                    涉及资金<reason type="money" classname="qksm money nullable" name="开展评价资金" v-model:value="qksm['开展评价资金']"></reason>万元。
                    <span class="hide_pdf">
                        <br />（是否委托第三方开展部门评价<reason type="select" classname="qksm select " name="是否第三方开展" v-model:value="qksm['是否第三方开展']"></reason>）<br />
                    </span>
                    <template v-if="qksm['是否第三方开展']=='是'">
                        其中，对
                        <reason type="textarea" classname="qksm" name="委托项目" v-model:value="qksm['委托项目']" placeholder="“*”“*”"></reason>等项目分别委托
                        <reason type="textarea" classname="qksm" name="第三方评价" v-model:value="qksm['第三方评价']" placeholder="“*”“*”"></reason>等第三方机构开展评价。
                    </template>
                    从评价情况来看，上述<reason type="integer" classname="qksm integer nullable" name="完成项目个数" v-model:value="qksm['完成项目个数']"></reason>个项目完成情况较好，
                    主要表现为：<reason type="textarea" classname="qksm widest nullable" name="部门评价主要表现" v-model:value="qksm['部门评价主要表现']" placeholder="项目立项程序完整、规范，设置了明确的绩效目标，财务相关管理制度较健全，预算执行及时、有效，群众满意度较高，基本实现了预期，……"></reason>
                </p>
                <p>
                    <b>（二）项目绩效自评结果。</b>
                    <b class="tipsText hide_pdf">（备注④：自评项目数量应与“(一)预算绩效管理工作开展情况”、自评情况汇总表保持一致；项目成效和存在的问题请根据部门自评工作总结情况简要概述）</b>
                </p>
                <p>
                    {{$store.state.divData.divname}}2020年度{{city}}级预算项目支出绩效自评的
                    <reason type="integer" classname="qksm integer" name="绩效自评项目" v-model:value="qksm['绩效自评项目']"></reason>个项目中，
                    <reason type="integer" classname="qksm integer" name="绩效自评优" v-model:value="qksm['绩效自评优']"></reason>个项目自评等级为优，
                    <reason type="integer" classname="qksm integer" name="绩效自评良" v-model:value="qksm['绩效自评良']"></reason>个项目自评等级为良，
                    <reason type="integer" classname="qksm integer" name="绩效自评中" v-model:value="qksm['绩效自评中']"></reason>个项目自评等级为中
                    <template v-if="!isPdf || num(qksm['绩效自评差'])>0">
                        ，
                        <reason type="integer" classname="qksm integer" name="绩效自评差" v-model:value="qksm['绩效自评差']"></reason>个项目自评等级为差
                    </template>。
                    <span v-if="num(qksm['绩效自评项目'])!=0">
                        从自评情况看，
                        <reason type="textarea" classname="qksm widest" name="绩效自评结果情况" v-model:value="qksm['绩效自评结果情况']" placeholder="项目支出绩效管理的重视程度进一步提升，大部分项目有序开展，执行和完成情况较好，资金使用比较规范，……，但也存在部分项目产出指标低于预期、项目实施进展慢等问题，……"></reason>
                    </span>
                </p>
                <p class="hide_pdf">
                    （绩效自评表是否涉密<reason type="select" classname="qksm select " name="自评表是否涉密" v-model:value="qksm['自评表是否涉密']"></reason>）<br />
                </p>
                <template v-if="qksm['自评表是否涉密']=='全部涉密'">
                    <p>本部门开展的绩效自评结果按规定不予公开。</p>
                    <p class="hide_pdf">
                        <b class="tipsText">若自评项目全部涉密，系统自动生成为“本部门开展的绩效自评结果按规定不予公开。”）</b>
                    </p>
                </template>
                <template v-else>
                    <p>
                        今年在部门决算中反映了2020年度预算项目支出绩效自评情况，以及
                        <reason type="textarea" classname="qksm" name="绩效自评情况" v-model:value="qksm['绩效自评情况']" placeholder="“*”“*”"></reason>等
                        <reason type="integer" classname="qksm integer must" name="绩效自评结果" v-model:value="qksm['绩效自评结果']"></reason>个项目的绩效自评具体结果。
                        <reason v-if="qksm['自评表是否涉密']=='部分涉密'" type="textarea" classname="qksm widest" name="自评表涉密说明" v-model:value="qksm['自评表涉密说明']" placeholder="若绩效自评表因部分涉密不能公开，请说明"></reason>
                        <!--<span v-if="isPdf && qksm['绩效自评结果项目']=='[未填]'">
                            本部门无项目绩效自评结果随2020年度决算向本级人大常委会报告。
                        </span>
                        <span v-else>
                            其中，<reason type="textarea" classname="qksm nullable" name="绩效自评结果项目" v-model:value="qksm['绩效自评结果项目']" placeholder="“*”"></reason>项目绩效自评结果随2020年度决算向{{city}}人大常委会报告。
                        </span>-->
                        <span v-if="!isPdf || qksm['绩效自评结果项目']!='[未填]'">
                            <b class="tipsText hide_pdf">(备注：此处数量应同自评表数量一致。）</b>
                            其中，<reason type="textarea" classname="qksm nullable" name="绩效自评结果项目" v-model:value="qksm['绩效自评结果项目']" placeholder="“*”"></reason>项目绩效自评结果随2020年度决算向{{city}}人大常委会报告。
                        </span>
                    </p>
                    <p v-if="isPdf && attachments.filter(e=>e.claims.tag=='jxzpb').length>0 && qksm['自评表是否涉密']!='是'">详见“第五部分 附件”。</p>
                    <p class="hide_pdf upload" @click="uploadJx('jxzpb')" v-if="num(qksm['绩效自评项目'])>0">*【->点此前往】上传绩效自评表</p>
                    <p class="hide_pdf">
                        <b class="tipsText">（自评表公开数量至少为3-5个，若自评项目总数不足3个，按照“应公开，尽公开”的原则，公开全部自评表；随2020年度决算向本级人大常委会报送的绩效自评表（如有）需进行公开；若因部分涉密不能公开，请说明，若无向本级人大常委会报告绩效自评结果的部门，“其中”后面不需要填写。”）</b>
                    </p>
                </template>
                <p>
                    <b>（三）财政评价项目绩效评价结果。</b>
                    <b class="tipsText hide_pdf">(备注⑥：部门无报人大的财政评价项目，该项不需要填写，系统自动生成：“本部门没有向{{city}}级人大常委会报告的财政评价项目。”）</b>
                </p>

                <p v-if="isPdf && qksm['开展绩效评价']=='[未填]' && qksm['开展绩效评价结果']=='[未填]'">
                    本部门没有向{{city}}级人大常委会报告的财政评价项目。
                </p>
                <template v-else>
                    <p>
                        {{city}}财政局对我部门<reason type="textarea" classname="qksm nullable" name="开展绩效评价" v-model:value="qksm['开展绩效评价']" placeholder="“*”"></reason>
                        项目开展绩效评价，并随2020年度决算向{{city}}人大常委会报告。该项目绩效评价综合得分
                        <reason type="money" classname="qksm money nullable" name="开展绩效评价得分" v-model:value="qksm['开展绩效评价得分']"></reason>，评价结果为
                        <reason type="textarea" classname="qksm nullable width3" name="开展绩效评价结果" v-model:value="qksm['开展绩效评价结果']" placeholder=""></reason>。
                    </p>
                    <p v-if="isPdf && attachments.filter(e=>e.claims.tag=='czpjjg').length>0">财政评价报告详见“第五部分 附件”。</p>
                </template>
                <p class="hide_pdf upload" @click="uploadJx('czpjjg')" v-if="!isEmptyStr(qksm['开展绩效评价'])">*【->点此前往】上传财政评价项目绩效评价报告</p>
                <p>
                    <b>（四）部门评价项目绩效评价结果。</b>
                    <b class="tipsText hide_pdf">(备注⑦：评价报告请上传，公开数量至少为1-2个。若本部门无部门评价项目，该项不需要填写，系统自动生成：“本部门无部门评价项目。”若部门评价项目全为涉密项目，请选择是否涉密为是，系统自动生成为“本部门开展的部门评价项目按规定不予公开。”）</b>
                </p>
                <p>
                    <span class="hide_pdf">
                        （是否涉密<reason type="select" classname="qksm select " name="部门评价是否涉密" v-model:value="qksm['部门评价是否涉密']"></reason>）<br />
                    </span>
                </p>
                <p v-if="qksm['部门评价是否涉密']=='是'">
                    本部门开展的部门评价项目均为涉密项目，不予公开。
                </p>
                <template v-else>
                    <p>
                        <span v-if="isPdf && qksm['绩效评价项目']=='[未填]' && qksm['绩效评价结果']=='[未填]。'">
                            本部门无部门评价项目。
                        </span>
                        <span v-else>
                            以
                            <reason type="textarea" classname="qksm nullable" name="绩效评价项目" v-model:value="qksm['绩效评价项目']" placeholder="“*”"></reason>项目为例，
                            该项目绩效评价综合得分
                            <reason type="money" classname="qksm money nullable must" name="绩效评价得分" v-model:value="qksm['绩效评价得分']"></reason>，评价结果为
                            <reason type="textarea" classname="qksm widest nullable" name="绩效评价结果" v-model:value="qksm['绩效评价结果']" placeholder="“*”"></reason>
                        </span>
                    </p>
                    <p v-if="isPdf && attachments.filter(e=>e.claims.tag=='bmpjjg').length>0">部门评价报告详见“第五部分 附件”。</p>
                    <p class="hide_pdf upload" @click="uploadJx('bmpjjg')" v-if="qksm['部门评价是否涉密']!='是' && !isEmptyStr(qksm['绩效评价项目'])">*【->点此前往】上传部门评价项目绩效评价报告</p>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm11",
        components: {
            reason,
        },
        data() {
            var qksm = this.$store.state.divData.qksm;
            qksm['评价报告是否涉密'] = qksm['评价报告是否涉密'] == '是' ? '是' : '否';
            qksm['自评表是否涉密'] = qksm['自评表是否涉密'] ? (qksm['自评表是否涉密'] == "是" ? "全部涉密" : qksm['自评表是否涉密']) : '否';
            qksm['是否第三方开展'] = qksm['是否第三方开展'] == '是' ? '是' : '否';
            qksm['部门评价是否涉密'] = qksm['部门评价是否涉密'] == '是' ? '是' : '否';
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
                city: '区',
                attachments: [],
            }
        },
        updated: function () {
            this.attachments = this.$store.state.divData.attachments
            this.inspect()
        },
        watch: {
            $route() {
                this.attachments = this.$store.state.divData.attachments
                this.inspect()
            },
        },
        methods: {
            uploadJx(name) {
                this.$router.push({ path: '/div/uploadPerform', query: { divid: this.$route.query.divid, tag: name }, });
            },
            inspect() {
                function notWrite(name) {
                    if (!name) {
                        name = ""
                    }
                    if (name.toString().indexOf('未填') > 0) {
                        //等于未填
                        return true
                    } else {
                        return false
                    }
                }
                if (this.num(this.qksm['绩效项目']) > 0 && this.num(this.qksm['涉及预算资金']) <= 0) {
                    this.addOrSet("qksm11", "请检查《十一、预算绩效情况说明》，如涵盖绩效的项目个数大于0，则涉及预算资金合计数必须大于0。");
                } else if (this.num(this.qksm['绩效项目']) == 0 && this.num(this.qksm['涉及预算资金']) != 0) {
                    this.addOrSet("qksm11", "请检查《十一、预算绩效情况说明》，如涵盖绩效的项目个数为0，则涉及预算资金合计数必须等于0。");
                } else {
                    this.remove("qksm11")
                }
                if (this.num(this.qksm['开展评价']) > 0 && this.num(this.qksm['开展评价资金']) <= 0) {
                    this.addOrSet("qksm111", "请检查《十一、预算绩效情况说明（一）预算绩效管理工作开展情况》，如开展绩效部门评价的项目个数大于0，则涉及资金合计数必须大于0。");
                } else if (this.num(this.qksm['开展评价']) == 0 && this.num(this.qksm['开展评价资金']) != 0) {
                    this.addOrSet("qksm111", "请检查《十一、预算绩效情况说明（一）预算绩效管理工作开展情况》，如开展绩效部门评价的项目个数为0，则涉及资金合计数必须等于0。");
                } else {
                    this.remove("qksm111")
                }
                if (this.num(this.qksm['开展评价']) > 0 && (this.num(this.qksm['完成项目个数']) == 0 || (notWrite(this.qksm['部门评价主要表现']) || this.isEmptyStr(this.qksm['部门评价主要表现'])))) {
                    this.addOrSet("qksm112", "请检查《十一、预算绩效情况说明（一）预算绩效管理工作开展情况》，如开展绩效部门评价的项目个数大于0，则部门评价项目需要进行完成情况阐述。");
                } else {
                    this.remove("qksm112")
                }
                if (this.num(this.qksm['绩效项目']) != this.num(this.qksm['绩效自评项目'])) {
                    this.addOrSet("qksm114", "请检查《十一、预算绩效情况说明》，开展预算绩效评价项目个数应与开展预算绩效评价项目个数相等。");
                } else {
                    this.remove("qksm114")
                }
                if (this.num(this.qksm['绩效自评项目']) != this.num(this.num(this.qksm['绩效自评优']) + this.num(this.qksm['绩效自评良']) + this.num(this.qksm['绩效自评中']) + this.num(this.qksm['绩效自评差']))) {
                    this.addOrSet("qksm115", "请检查《十一、预算绩效情况说明》，开展绩效自评项目总数应等于各等级分项项目个数之和。");
                } else {
                    this.remove("qksm115")
                }
                if (this.num(this.qksm['绩效自评结果']) > 5) {
                    this.addOrSet("qksm116", "请检查《十一、预算绩效情况说明》，上传项目绩效自评表附件个数请控制在3-5个，实际情况不足3个，可按实际数量上传，最多不超过五个。");
                } else {
                    this.remove("qksm116")
                }
                //通用
                //上传绩效自评情况汇总表
                if (this.num(this.qksm['绩效项目']) == 0 && this.attachments.filter(e => e.claims.tag == 'zphzb').length > 0) {
                    this.addOrSet("file11", "请检查《十一、预算绩效情况说明》，绩效自评涵盖项目等于0个项目时，应删除对应绩效自评情况汇总文件。");
                } else if (this.num(this.qksm['绩效项目']) > 0 && (this.attachments.filter(e => e.claims.tag == 'zphzb').length) == 0) {
                    this.addOrSet("file11", "请检查《十一、预算绩效情况说明》，绩效自评涵盖项目大于0个项目时，应上传对应绩效自评情况汇总文件。");
                } else {
                    this.remove("file11")
                }
                //上传绩效评价自评表
                if (this.num(this.qksm['绩效自评项目']) == 0 && this.attachments.filter(e => e.claims.tag == 'jxzpb').length > 0) {
                    this.addOrSet("file21", "请检查《十一、预算绩效情况说明》，开展绩效自评项目等于0个项目时，应删除对应绩效自评文件。");
                } else if (this.num(this.qksm['绩效自评项目']) > 0 && this.qksm['自评表是否涉密'] != '全部涉密' && this.attachments.filter(e => e.claims.tag == 'jxzpb').length == 0) {
                    this.addOrSet("file21", "请检查《十一、预算绩效情况说明》，开展绩效自评项目大于0个项目并且绩效自评项目不是全部涉密时，应上传对应绩效自评文件。");
                } else {
                    this.remove("file21")
                }
                if (this.qksm['自评表是否涉密'] == '全部涉密' && this.attachments.filter(e => e.claims.tag == 'jxzpb').length > 0) {
                    this.addOrSet("file22", "请检查《十一、预算绩效情况说明》，开展绩效自评项目均为涉密项目时，应删除对应绩效自评文件。");
                } else {
                    this.remove("file22")
                }
                //单位
                //上传绩效评价报告
                if (this.$store.state.divData.type == 0) {
                    if (this.num(this.qksm['开展评价']) == 0 && this.attachments.filter(e => e.claims.tag == 'jxpjbg').length > 0) {
                        this.addOrSet("file11d", "请检查《十一、预算绩效情况说明》，开展重点绩效评价项目等于0个项目时，应删除对应绩效评价报告文件。");
                    } else if (this.num(this.qksm['开展评价']) > 0 && this.qksm['评价报告是否涉密'] != '是' && this.attachments.filter(e => e.claims.tag == 'jxpjbg').length == 0) {
                        this.addOrSet("file11d", "请检查《十一、预算绩效情况说明》，开展重点绩效评价项目大于0个项目并且绩效评价项目不涉密时，应上传对应绩效评价报告文件。");
                    } else {
                        this.remove("file11d")
                    }
                    if (this.qksm['评价报告是否涉密'] == '是' && this.attachments.filter(e => e.claims.tag == 'jxpjbg').length > 0) {
                        this.addOrSet("file12d", "请检查《十一、预算绩效情况说明》，开展重点绩效评价项目均为涉密项目时，应删除对应绩效评价报告文件。");
                    } else {
                        this.remove("file12d")
                    }
                } else {
                    let scoreName = notWrite(this.qksm['整体绩效等级']) || this.isEmptyStr(this.qksm['整体绩效等级'])
                    let scoreResult = notWrite(this.qksm['整体绩效自评情况']) || this.isEmptyStr(this.qksm['整体绩效自评情况'])
                    let scoreScore = this.num(this.qksm['整体绩效得分']) == 0 || this.isEmptyStr(this.qksm['整体绩效得分'])
                    if ((((notWrite(!this.qksm['整体绩效等级']) || !this.isEmptyStr(this.qksm['整体绩效等级'])) && (scoreResult || scoreScore))
                        || ((!notWrite(this.qksm['整体绩效自评情况']) || !this.isEmptyStr(this.qksm['整体绩效自评情况'])) && (scoreName || scoreScore))
                        || ((this.qksm['整体绩效得分'] != 0 || !this.isEmptyStr(this.qksm['整体绩效得分'])) && (scoreName || scoreResult)))
                        && (!scoreName || !scoreResult || !scoreScore)) {
                        this.addOrSet("score", "请检查《十一、预算绩效情况说明》，组织开展部门整体绩效自评情况需填写完整。");
                    } else {
                        this.remove("score")
                    }
                    let isThree = Boolean
                    let isFour = Boolean
                    if (this.isPdf) {
                        isThree = notWrite(this.qksm['开展绩效评价']) || this.isEmptyStr(this.qksm['开展绩效评价'])
                        isFour = notWrite(this.qksm['绩效评价项目']) || this.isEmptyStr(this.qksm['绩效评价项目'])
                    } else {
                        isThree = this.isEmptyStr(this.qksm['开展绩效评价'])
                        isFour = this.isEmptyStr(this.qksm['绩效评价项目'])
                    }
                    //部门
                    //上传财政评价项目绩效评价结果
                    if (isThree && this.attachments.filter(e => e.claims.tag == 'czpjjg').length > 0) {
                        this.addOrSet("file31", "请检查《十一、预算绩效情况说明》，无财政评价项目绩效项目时，应删除对应财政评价项目绩效评价结果文件。");
                    } else if (!isThree && this.attachments.filter(e => e.claims.tag == 'czpjjg').length == 0) {
                        this.addOrSet("file31", "请检查《十一、预算绩效情况说明》，有财政评价项目绩效项目时，应上传对应财政评价项目绩效评价结果文件。");
                    } else {
                        this.remove("file31")
                    }
                    //上传部门评价项目绩效评价结果
                    if (isFour && this.attachments.filter(e => e.claims.tag == 'bmpjjg').length > 0) {
                        this.addOrSet("file41", "请检查《十一、预算绩效情况说明》，无部门评价项目绩效项目时，应删除对应部门评价项目绩效评价结果文件。");
                    } else if (!isFour && this.qksm['部门评价是否涉密'] != '是' && this.attachments.filter(e => e.claims.tag == 'bmpjjg').length == 0) {
                        this.addOrSet("file41", "请检查《十一、预算绩效情况说明》，有部门评价项目绩效项目并且部门评价不涉密时，应上传对应部门评价项目绩效评价结果文件。");
                    } else {
                        this.remove("file41")
                    }
                    if (this.qksm['部门评价是否涉密'] == '是' && this.attachments.filter(e => e.claims.tag == 'bmpjjg').length > 0) {
                        this.addOrSet("file42", "请检查《十一、预算绩效情况说明》，部门评价项目绩效项目均为涉密项目时，应删除对应部门评价项目绩效评价结果文件。");
                    } else {
                        this.remove("file42")
                    }

                    //三部分三框判断
                    let threeName = notWrite(this.qksm['开展绩效评价']) || this.isEmptyStr(this.qksm['开展绩效评价'])
                    let threeResult = notWrite(this.qksm['开展绩效评价结果']) || this.isEmptyStr(this.qksm['开展绩效评价结果'])
                    let threeScore = this.num(this.qksm['开展绩效评价得分']) == 0 || this.isEmptyStr(this.qksm['开展绩效评价得分'])
                    if ((((notWrite(!this.qksm['开展绩效评价']) || !this.isEmptyStr(this.qksm['开展绩效评价'])) && (threeResult || threeScore))
                        || ((!notWrite(this.qksm['开展绩效评价结果']) || !this.isEmptyStr(this.qksm['开展绩效评价结果'])) && (threeName || threeScore))
                        || ((this.qksm['开展绩效评价得分'] != 0 || !this.isEmptyStr(this.qksm['开展绩效评价得分'])) && (threeName || threeResult)))
                        && (!threeName || !threeResult || !threeScore)) {
                        this.addOrSet("jixiao3", "请检查《十一、预算绩效情况说明（三）财政评价项目绩效评价结果》，财政评价项目绩效项目名称、评价得分、评价结果均为必填。");
                    } else {
                        this.remove("jixiao3")
                    }
                    //四部分三框判断
                    let fourName = notWrite(this.qksm['绩效评价项目']) || this.isEmptyStr(this.qksm['绩效评价项目'])
                    let fourResult = notWrite(this.qksm['绩效评价结果']) || this.isEmptyStr(this.qksm['绩效评价结果'])
                    let fourScore = this.isEmptyStr(this.qksm['绩效评价得分'])
                    if (this.qksm['部门评价是否涉密'] != '是') {
                        if ((((!notWrite(this.qksm['绩效评价项目']) || !this.isEmptyStr(this.qksm['绩效评价项目'])) && (fourResult || fourScore))
                            || ((!notWrite(this.qksm['绩效评价结果']) || !this.isEmptyStr(this.qksm['绩效评价结果'])) && (fourName || fourScore))
                            || (!this.isEmptyStr(this.qksm['绩效评价得分']) && (fourName || fourResult)))
                            && (!fourName || !fourResult || !fourScore)) {
                            this.addOrSet("jixiao4", "请检查《十一、预算绩效情况说明（四）部门评价项目绩效评价结果》，部门评价项目绩效项目名称、评价得分、评价结果均为必填。");
                        } else {
                            this.remove("jixiao4")
                        }
                    } else {
                        this.remove("jixiao4")
                    }
                }
            }
        }
    };
</script>
<style scoped>
    .upload {
        color: #9ECADF;
        font-weight: 600;
    }

    .tipsText {
        color: red;
        font-style: italic
    }
</style>
